import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

// .alert — the design system's geometry. Margin is left to the caller so the
// primitive stays layout-neutral (the DS class bakes in mb-4).
const alertVariants = cva(
  "relative w-full rounded-xl border px-4 py-3 text-sm text-primary-900",
  {
    variants: {
      variant: {
        default: "border-info-300 bg-info-50",
        // .alert-info
        info: "border-primary-900 bg-primary-50",
        // .alert-error
        destructive: "border-danger-900 bg-danger-50",
        // Warning and success have no counterpart in the palette
        // (primary/danger/info + gray only) — the two deliberate exceptions.
        warning: "border-amber-300 bg-amber-50 text-amber-900",
        success: "border-green-200 bg-green-50 text-green-800",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Alert({ className, variant, ref, ...props }) {
  return (
    <div
      ref={ref}
      role="alert"
      className={cn(alertVariants({ variant }), className)}
      {...props}
    />
  );
}

function AlertTitle({ className, ref, ...props }) {
  return (
    <h5
      ref={ref}
      className={cn("mb-1 font-semibold font-display leading-none tracking-tight", className)}
      {...props}
    />
  );
}

function AlertDescription({ className, ref, ...props }) {
  return (
    <div ref={ref} className={cn("text-sm", className)} {...props} />
  );
}

export { Alert, AlertTitle, AlertDescription };
